export default function useScrubberCollectionWithCustomFields(collection) {
  return collection.map(item => {
    return {
      ...item,
      ...Object.fromEntries(
        item.customFields
          ?.filter(field => field.customFieldTemplate?.id)
          ?.map(field => [
            `customField${field.customFieldTemplate.id}`,
            field.value,
          ]) || []
      ),
    };
  });
}
